import React from "react";
import ReactDOM from "react-dom/client";
import { Buffer } from "buffer";

import App from "./App";
import "./index.css";

/* =========================================
   POLYFILLS
========================================= */

window.Buffer = Buffer;

const root =
  ReactDOM.createRoot(
    document.getElementById("root")
  );

root.render(
  <App />
);